import { User } from "views/settings-users/types";

import { NO_ASSIGNEE_ID } from "./constants";
import type { Assignee, AssigneeOption } from "./types";

export const sortAssignees = (
  assignees: User[] | undefined,
  currentUserId?: number
): User[] => {
  if (!assignees) return [];
  const sorted = assignees.toSorted((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });
  if (currentUserId && assignees.some((a) => a.id === currentUserId)) {
    const withoutAuth = sorted.filter((a) => a.id !== currentUserId);
    const currentUser = assignees.find((a) => a.id === currentUserId);
    return currentUser ? [currentUser, ...withoutAuth] : sorted;
  }
  return sorted;
};

const UNASSIGNED_OPTION: AssigneeOption = {
  label: "No assignee",
  value: "unassigned",
  kind: "unassigned"
};

export const buildOptions = (sortedAssignees: User[]): AssigneeOption[] => [
  UNASSIGNED_OPTION,
  ...sortedAssignees.map((assignee) => ({
    label: assignee.name,
    value: assignee.id,
    id: assignee.id,
    kind: "user" as const,
    user: { id: assignee.id, name: assignee.name }
  }))
];

export const buildAssigneesParam = (
  ids: number[] | null
): Assignee[] | undefined => {
  if (!ids || ids.length === 0) return undefined;

  return [
    ...ids
      .filter((id) => id !== NO_ASSIGNEE_ID)
      .map((id) => ({
        subject_type: "partner_user" as const,
        subject_id: id
      })),
    ...(ids.includes(NO_ASSIGNEE_ID)
      ? [{ subject_type: "no_assignee" as const }]
      : [])
  ];
};
